/**
 * I messaggi diretti della Community v2 sono stati rimossi il 2026-10-15 e
 * sostituiti dalla Chat associati. I vecchi indirizzi (per esempio i link delle
 * notifiche già inviate) portano alla chat.
 */
export const VECCHIE_ROTTE_MESSAGGI_COMMUNITY = [
  '/area-riservata/community-v2/messaggi',
  '/area-riservata/community-v2/messaggi/:id',
];

export const DESTINAZIONE_VECCHI_MESSAGGI = '/area-riservata/chat';
